/* Engraved can product page: behaviour for the story sections.
   - "Read the can": hovering a numbered callout lights its pin on the photo
     and the other way round; the pins land in order once, when the can
     scrolls into view (the page's one authored motion; skipped under reduced
     motion, and the pins are visible by default if this file never runs).
   - "Back to the buy box" links scroll to the main product form and focus
     Add to cart. They never submit the form: the cart flow stays the theme's.
   Idempotent; safe in the theme editor (re-runs on section load). */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function anatomy(root) {
    $$('.pa-can-anatomy', root).forEach(function (sec) {
      if (sec.dataset.pcReady) return;
      sec.dataset.pcReady = '1';

      var pins = $$('.pa-can-anatomy__pin', sec);
      var items = $$('.pa-can-anatomy__item', sec);

      function light(i, on) {
        if (pins[i]) pins[i].classList.toggle('is-active', on);
        if (items[i]) items[i].classList.toggle('is-active', on);
      }

      [pins, items].forEach(function (list) {
        list.forEach(function (el, i) {
          el.addEventListener('mouseenter', function () { light(i, true); });
          el.addEventListener('mouseleave', function () { light(i, false); });
        });
      });

      if (REDUCED || !('IntersectionObserver' in window) || !pins.length) return;
      var fig = sec.querySelector('.pa-can-anatomy__figure');
      var rect = fig && fig.getBoundingClientRect();
      // Already on screen (or above it): leave the pins as they are.
      if (!fig || rect.top < window.innerHeight * 0.9) return;
      sec.dataset.pins = 'armed';
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          sec.dataset.pins = 'in';
          io.disconnect();
        });
      }, { threshold: 0.35 });
      io.observe(fig);
    });
  }

  function buyBox() {
    return document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('.product-info--offer-builder');
  }

  function toBuyBox(e) {
    var box = buyBox();
    if (!box) return;
    e.preventDefault();
    var target = box.querySelector('.product-form__submit') || box;
    var top = (box.querySelector('.product__title, h1') || box).getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED ? 'auto' : 'smooth' });
    setTimeout(function () {
      if (target && target.focus) target.focus({ preventScroll: true });
    }, REDUCED ? 0 : 500);
  }

  function links(root) {
    $$('[data-pa-can-buy]', root).forEach(function (a) {
      if (a.dataset.pcReady) return;
      a.dataset.pcReady = '1';
      a.addEventListener('click', toBuyBox);
    });
  }

  function run(root) {
    anatomy(root);
    links(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);

  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
